<template>
    <transition name="fade">
            <Games v-if="!isDesktop"/>

            <div class="desktop-games page" v-else>

            <GameHero v-if="feature" :feature="feature"/>

            <div v-if="history.length > 0" class="games-section">
                <h3>Recently Played</h3>
                <div class="games-grid scroll">
                    <Game :game="g" v-ripple size="short" v-for="(g, i) in history" :key="'hist-' + i"/>
                </div>
            </div>

            <GameParty />
            <GameStream />

            <div v-if="saved.length > 0" class="games-section">
                <h3>Favourites</h3>
                <div class="games-grid scroll">
                    <Saved v-for="(g,i) in saved" :key="i" :saved="g" v-ripple/>
                </div>
            </div>


            <div class="console-filters">
                <div v-for="(t, i) in tagcons" :key="i"
                    class="console-pill"
                    :class="{ active: activeCon === t }"
                    v-ripple
                    @click="setActiveCon(t)"
                >{{ t }}</div>
            </div>

            <div v-if="activeCon" class="games-section">
                <h3>{{ activeCon }} Games</h3>
                <div class="games-grid scroll">
                    <Game :game="g" v-ripple v-for="(g, i) in gamesByConsole(activeCon)" :key="'con-' + i" />
                </div>
            </div>

            <div class="tag-filters">
                <div v-for="(t, i) in tagssels" :key="i"
                    class="tag-pill"
                    :class="{ active: activeTag === t }"
                    v-ripple
                    @click="setActiveTag(t)"
                >{{ t }}</div>
            </div>

            <div v-if="activeTag" class="games-section">
                <h3>{{ activeTag }} Games</h3>
                <div class="games-grid scroll">
                    <Game :game="g" v-ripple  v-for="(g, i) in games.filter(g => g.tags.includes(activeTag))" :key="'tag-' + i"/>
                </div>
            </div>

            <div v-if="feature" class="games-section">
                <h3>Editor's Choice</h3>
                <div class="games-grid">

                    <Game :game="g" v-ripple v-for="(g, i) in gamesInCat('fav')" :key="'fav-' + i" />
                </div>
            </div>

        </div>
    </transition>
</template>

<script>
const GameHero = () => import("@/components/desktop/GameHero.vue");
const Games = () => import("@/views/Games.vue");
import Game from '@/components/Game.vue'
import Saved from '@/components/Saved.vue'
import GameStream from '@/components/GameStream.vue'
import GameParty from '@/components/GameParty.vue'

export default {
    name: 'DesktopGames',

    components: {
        GameHero,
        Games,
        Saved,
        Game,
        GameStream,
        GameParty,
    },

    data() {
        return {
            tags: ['fighting', 'sim', 'indie', 'current gen', 'puzzle', 'platformer', 'sports', 'beat-em-up', 'racing', 'open world', 'shooter', 'arcade', 'RPG', 'classic', 'retro', 'AAA', 'inclusive', 'comic book'],
            tag: null,
            ready: false,
            tagssels: [],
            tagcons: [],
            activeTag: '',
            activeCon: '',
            games: [],
            history: [],
            saved: [],
            gameSearchOpen: false,
            gameSearchQuery: '',
            searchGames: [],
            feature: null,
        }
    },

    methods: {
        gamesInCat(cat) {
            return this.games.filter(g => g.tags.includes(cat))
        },

        gamesByConsole(cons) {
            return this.games.filter(g => g.console.includes(cons))
        },

        async getFeature() {
            const game = window.shuffle(this.games)
            this.feature = game[0]
            this.tag = window.shuffle(this.tags)[0]
            this.tags = window.shuffle(this.tags)
            this.tagssels = this.tags.splice(0, 6)
            this.activeTag = this.tagssels[0]
            this.tagcons = window.shuffle(['PSP', 'PS2', 'PS3', 'NES', 'Wii', 'N64', 'GC', 'Native', 'Switch'])
            this.activeCon = this.feature.console
        },

        setActiveTag(t) { this.activeTag = t },
        setActiveCon(t) { this.activeCon = t },

        openGameSearch() {
            this.gameSearchOpen = true
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },

        closeGameSearch() {
            this.gameSearchOpen = false
            this.searchGames = this.games
            this.gameSearchQuery = ''
        },

        searching() {
            this.gameSearchQuery = this.$refs.input.value
            this.searchGames = this.games.filter(x =>
                x.title.toLowerCase().includes(this.gameSearchQuery.toLowerCase())
            )
        },

        async loadGames() {
            let request = await window.afetch('/games')
            let data = await request.json()
            this.games = data.games
            this.saved = data.saved
            this.history = data.history
            this.searchGames = this.games
            this.ready = true
            this.getFeature()
        },

    },

    activated() {
        document.title = 'Arcade & Cloud Gaming - QB'
    },

    mounted() {
        document.title = 'Arcade & Cloud Gaming - QB'
        this.loadGames()
    },
}
</script>

<style lang="scss" scoped>
.desktop-games { }

.games-section {
    padding: 0;
    margin-bottom: 40px;

    h3 {
        margin: 0 0 16px 0;
        font-size: 18px;
        font-weight: 600;
        padding: 0 48px;
    }
}

.games-grid {
    display: flex;
    flex-wrap: wrap;
    padding: 0 48px;
    //grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 16px;
    &.scroll{
        gap: 8px;
        flex-wrap: nowrap;
        overflow-x: scroll;
    }

}

.console-filters,
.tag-filters {
    display: flex;
    gap: 8px;
    padding: 0 48px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    .console-pill,
    .tag-pill {
        padding: 6px 14px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 12px;
        background-color: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.15);
        transition: all 0.2s;

        &:hover {
            background-color: rgba(255, 255, 255, 0.15);
        }

        &.active {
            background-color: white;
            color: black;
            border-color: white;
        }
    }
}

</style>
